import {dehydrate, QueryClient} from '@tanstack/react-query';
import {useRouter} from 'next/router';

import {disallowSlug, RENDER_MODES} from '@udemy/nextjs-core';
import {SubscriptionPlanProductType, SubscriptionPlansProvider} from '@udemy/subscription-graphql';

import {
    type RolePlayLandingPageFeatureProps,
    RolePlayLandingPageFeature,
} from 'src/features/role-play-landing-page';
import {useCanonicalUrl} from 'src/hooks/useCanonicalUrl';
import {getCompactTranslations} from 'src/lib-server/locale.server';
import {FOUR_HOURS} from 'src/lib/constants';
import {META_DEFAULT_BASE_URL} from 'src/lib/constants';
import {AppContextData} from 'src/types/page-props';

import {getLayout} from '../../components/layout';
import {getStaticAppContext} from '../api/context.api';

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: 'blocking',
    };
}

export const getStaticProps = disallowSlug(async ({locale}) => {
    locale = locale as string;
    const translations = await getCompactTranslations(locale);
    const client = new QueryClient();

    const [staticData] = await Promise.all([getStaticAppContext({locale})]);

    const appContext: AppContextData = {
        ...staticData,
    };

    return {
        props: {
            appContext,
            dehydratedState: dehydrate(client),
            locale,
            pageKey: 'role_play_landing_page',
            renderMode: RENDER_MODES.ISR,
            translations,
        },
        revalidate: FOUR_HOURS,
    };
});

export default function RolePlayLandingPage(props: RolePlayLandingPageFeatureProps) {
    const router = useRouter();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);
    return (
        <SubscriptionPlansProvider
            subscriptionPlanQueryVariables={[
                {
                    filters: {
                        productType: SubscriptionPlanProductType.Consumersubscription,
                    },
                    marketingURL: `${new URL(canonicalUrl).origin}${router.asPath}`,
                },
            ]}
        >
            <RolePlayLandingPageFeature {...props} />
        </SubscriptionPlansProvider>
    );
}

RolePlayLandingPage.getLayout = getLayout;
